const getters = {
    selfInfo: (state) => state.app.selfInfo,
    userInfo: (state) => state.app.userInfo,
    isUserInfoHasValue: (state) => {
        return JSON.stringify(state.app.userInfo) !== '{}';
    },
    darkbg: (state) => state.app.darkbg,
    darkColor: (state) => state.app.darkColor,
    HTisLogin: (state) => state.app.HTisLogin,
    configData: (state) => state.app.configData,
    processConfig: (state) => {
        if (state.app.processConfig) {
            return state.app.processConfig[state.ringtone.carrierType];
        }
        else {
            return {
                page: false,
                dialog: false,
                rules: '',
                protocolStatus: false,
                dialogTitle: '',
                dialogContent: '',
                dialogBtn: ''
            };
        }
    }
};
export default getters;
